import { ref } from 'vue';
import { researchProposals } from '@/api/admin';

export default () => {
  const hasOpenResearchRequests = ref(false);

  const fetchOpenResearchRequestCount = async () => {
    const response = await researchProposals.openCount();
    if (response.status !== 200) {
      hasOpenResearchRequests.value = false;
      return 0;
    }
    const count = Number(response.data?.count || 0);
    hasOpenResearchRequests.value = count > 0;
    return count;
  };

  return {
    hasOpenResearchRequests,
    fetchOpenResearchRequestCount,
  };
};
